var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lazy-image",on:{"click":_vm.onClick}},[_c('lazy-image-loader',{attrs:{"src":_vm.src},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
return [_c('div',{staticClass:"lazy-image__background",style:({ backgroundImage: ("url(" + _vm.src + ")") })}),_c('div',{staticClass:"lazy-image__foreground",class:{ loading: loading }})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }